import { Routes, mapToCanActivate, mapToResolve } from '@angular/router';
import { LocationGuard } from '@next/core-lib/relationships';
import { Observable } from 'rxjs';

import { DeliveryOverviewComponent } from './components/delivery-overview/delivery-overview.component';
import { DeliveryOverviewResolver } from './resolvers/delivery-overview.resolver';

export const deliveryRoutes: Routes = [
  {
    path: '',
    component: DeliveryOverviewComponent,
    canActivate: mapToCanActivate([LocationGuard]),
    resolve: {
      data: mapToResolve<Observable<boolean>>(DeliveryOverviewResolver),
    },
  },
];
